(() => {
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

  function setSlide(carousel, index) {
    const slides = qsa('[data-ref-slide]', carousel);
    const dots = qsa('[data-ref-dot]', carousel);
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    carousel.dataset.active = String(next);
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === next;
      slide.classList.toggle('active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('active', dotIndex === next);
      dot.setAttribute('aria-current', String(dotIndex === next));
    });
  }

  function initCarousels(root = document) {
    qsa('[data-ref-carousel]', root).forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      carousel.dataset.active = '0';
      setSlide(carousel, 0);
      const slides = qsa('[data-ref-slide]', carousel);
      const toggle = carousel.querySelector('[data-ref-carousel-toggle]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false, hovered = false, focused = false;
      const stop = () => { window.clearInterval(carousel.refTimer); carousel.refTimer = undefined; };
      const resume = () => {
        stop();
        const canRotate = carousel.dataset.autoplay === 'true' && slides.length > 1 && !motion.matches;
        if (toggle) {
          toggle.hidden = !canRotate;
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.querySelector('[data-hero-pause-icon]')?.toggleAttribute('hidden', paused);
          toggle.querySelector('[data-hero-play-icon]')?.toggleAttribute('hidden', !paused);
        }
        if (canRotate && !paused && !hovered && !focused && !document.hidden && carousel.isConnected) {
          carousel.refTimer = window.setInterval(() => setSlide(carousel, Number(carousel.dataset.active || 0) + 1), Math.max(4000, Number(carousel.dataset.interval || 6000)));
        }
      };
      const move = (delta) => { setSlide(carousel, Number(carousel.dataset.active || 0) + delta); resume(); };
      carousel.querySelector('[data-ref-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-ref-next]')?.addEventListener('click', () => move(1));
      qsa('[data-ref-dot]', carousel).forEach((dot) => dot.addEventListener('click', () => { setSlide(carousel, Number(dot.dataset.index || 0)); resume(); }));
      toggle?.addEventListener('click', () => { paused = !paused; resume(); });
      carousel.addEventListener('pointerenter', () => { hovered = true; resume(); });
      carousel.addEventListener('pointerleave', () => { hovered = false; resume(); });
      carousel.addEventListener('focusin', () => { focused = true; resume(); });
      carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); resume(); });
      document.addEventListener('visibilitychange', resume);
      motion.addEventListener('change', resume);
      const onSelect = event => {
        const index = slides.indexOf(event.target.closest('[data-ref-slide]'));
        if (index < 0) return;
        paused = true; setSlide(carousel, index); resume();
      };
      const onUnload = event => {
        if (!event.target.contains(carousel)) return;
        stop(); document.removeEventListener('visibilitychange', resume); motion.removeEventListener('change', resume);
        document.removeEventListener('shopify:block:select', onSelect); document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:block:select', onSelect);
      document.addEventListener('shopify:section:unload', onUnload);
      resume();
    });
  }

  function initAnnouncement(root = document) {
    qsa('[data-ira-ref-announcement]', root).forEach((bar) => {
      if (bar.dataset.ready === 'true') return;
      bar.dataset.ready = 'true';
      const slides = qsa('[data-announcement-slide]', bar);
      const controls = qsa('[data-announcement-prev], [data-announcement-next]', bar);
      const toggle = bar.querySelector('[data-announcement-toggle]');
      controls.forEach(button => { button.hidden = slides.length < 2; });
      if (!slides.length) { bar.hidden = true; return; }
      let index = 0;
      let timer;
      let hovered = false;
      let focused = false;
      let paused = false;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const text = bar.querySelector('[data-announcement-text]');
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; });
        if (!motion.matches) slides[index].animate?.([{ opacity: 0 }, { opacity: 1 }], { duration: 220 });
      };
      const stop = () => { window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        const canRotate = bar.dataset.refAnnouncementAutoplay === 'true' && !motion.matches && slides.length > 1;
        if (toggle) {
          toggle.hidden = !canRotate;
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.querySelector('[data-announcement-pause-icon]')?.toggleAttribute('hidden', paused);
          toggle.querySelector('[data-announcement-play-icon]')?.toggleAttribute('hidden', !paused);
        }
        if (text) text.setAttribute('aria-live', focused || paused || !canRotate ? 'polite' : 'off');
        if (!canRotate || paused || hovered || focused || document.hidden || !bar.isConnected) return;
        timer = window.setInterval(() => show(index + 1), Math.max(3000, Number(bar.dataset.refAnnouncementInterval || 5000)));
      };
      const move = (delta) => { start(); show(index + delta); };
      bar.querySelector('[data-announcement-prev]')?.addEventListener('click', () => move(-1));
      bar.querySelector('[data-announcement-next]')?.addEventListener('click', () => move(1));
      toggle?.addEventListener('click', () => { paused = !paused; start(); });
      bar.addEventListener('pointerenter', () => { hovered = true; start(); });
      bar.addEventListener('pointerleave', () => { hovered = false; start(); });
      bar.addEventListener('focusin', () => { focused = true; start(); });
      bar.addEventListener('focusout', event => { focused = bar.contains(event.relatedTarget); start(); });
      document.addEventListener('visibilitychange', start);
      motion.addEventListener('change', start);
      const onSelect = event => {
        const selected = event.target.closest('[data-announcement-slide]');
        const selectedIndex = slides.indexOf(selected);
        if (selectedIndex < 0) return;
        paused = true;
        start();
        show(selectedIndex);
      };
      document.addEventListener('shopify:block:select', onSelect);
      const onUnload = event => {
        if (!event.target.contains(bar)) return;
        stop();
        document.removeEventListener('visibilitychange', start);
        motion.removeEventListener('change', start);
        document.removeEventListener('shopify:block:select', onSelect);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
      show(0);
      start();
    });
  }

  function initOfferStrips(root = document) {
    qsa('[data-ref-offer-strip]', root).forEach((strip) => {
      if (strip.dataset.ready === 'true') return;
      strip.dataset.ready = 'true';
      const items = qsa('[data-ref-offer-item]', strip).filter((item) => item.textContent.trim());
      if (!items.length) return;
      let index = 0;
      let timer;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (next) => {
        index = (next + items.length) % items.length;
        items.forEach((item, itemIndex) => { item.hidden = itemIndex !== index; });
        if (!reducedMotion) {
          items[index].animate(
            [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 280, easing: 'ease-out' },
          );
        }
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (strip.dataset.refOfferAutoplay !== 'true' || reducedMotion || items.length < 2) return;
        timer = window.setInterval(() => show(index + 1), Math.max(3000, Number(strip.dataset.refOfferInterval || 5000)));
      };
      const move = (delta) => {
        show(index + delta);
        start();
      };
      strip.querySelector('[data-ref-offer-prev]')?.addEventListener('click', () => move(-1));
      strip.querySelector('[data-ref-offer-next]')?.addEventListener('click', () => move(1));
      strip.addEventListener('pointerenter', stop);
      strip.addEventListener('pointerleave', start);
      strip.addEventListener('focusin', stop);
      strip.addEventListener('focusout', start);
      show(0);
      start();
    });
  }

  function initDesktopMenus(header) {
    const nav = header.querySelector('.desktop-nav');
    if (!nav || nav.dataset.iraDropdownsReady) return;
    const desktop = window.matchMedia('(min-width:761px)');
    const controller = new AbortController();
    const listen = (node, type, handler) => node.addEventListener(type, handler, { signal: controller.signal });
    const entries = [...nav.children].map((item, index) => {
      const trigger = item.querySelector(':scope > a, :scope > .nav-parent');
      const panel = item.querySelector(':scope > .mega-menu');
      if (!trigger || !panel) return null;
      panel.id ||= `IRADesktopMenu-${header.closest('[id]')?.id || 'header'}-${index}`;
      trigger.setAttribute('aria-controls', panel.id);
      return { item, trigger, panel, timer: null, hovered: false, pinned: false, pressedOpen: null };
    }).filter(Boolean);
    const clearTimer = (entry) => { window.clearTimeout(entry.timer); entry.timer = null; };
    const close = (entry) => {
      clearTimer(entry);
      entry.pinned = false;
      entry.item.classList.remove('is-menu-open');
      entry.trigger.setAttribute('aria-expanded', 'false');
      entry.panel.setAttribute('aria-hidden', 'true');
      entry.panel.inert = true;
    };
    const open = (entry, pinned = false) => {
      if (!desktop.matches) return;
      entries.forEach((other) => { if (other !== entry) close(other); });
      clearTimer(entry);
      entry.pinned ||= pinned;
      entry.item.classList.add('is-menu-open');
      entry.trigger.setAttribute('aria-expanded', 'true');
      entry.panel.setAttribute('aria-hidden', 'false');
      entry.panel.inert = false;
    };
    const scheduleClose = (entry) => {
      clearTimer(entry);
      entry.timer = window.setTimeout(() => {
        if (!entry.hovered && !entry.pinned && !entry.item.contains(document.activeElement)) close(entry);
      }, 300);
    };
    let restoringFocus = false;
    entries.forEach((entry) => {
      close(entry);
      listen(entry.item, 'pointerenter', (event) => {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') return;
        entry.hovered = true;
        open(entry);
      });
      listen(entry.item, 'pointerleave', (event) => {
        entry.hovered = false;
        // Keep the menu available while crossing the navigation row diagonally.
        if (nav.contains(event.relatedTarget)) return;
        scheduleClose(entry);
      });
      listen(entry.item, 'focusin', () => {
        if (!restoringFocus && entry.pressedOpen === null) open(entry);
      });
      listen(entry.item, 'focusout', (event) => {
        if (!entry.item.contains(event.relatedTarget)) { entry.pinned = false; scheduleClose(entry); }
      });
      listen(entry.trigger, 'pointerdown', () => { entry.pressedOpen = entry.item.classList.contains('is-menu-open'); });
      listen(entry.trigger, 'pointercancel', () => { entry.pressedOpen = null; });
      listen(entry.trigger, 'click', (event) => {
        const pressedOpen = entry.pressedOpen;
        entry.pressedOpen = null;
        if (!desktop.matches || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        if (pressedOpen === false || !entry.item.classList.contains('is-menu-open')) {
          event.preventDefault();
          open(entry, true);
        }
      });
      listen(entry.trigger, 'keydown', (event) => {
        entry.pressedOpen = null;
        if (!desktop.matches || !['ArrowDown', 'ArrowUp', ' '].includes(event.key)) return;
        event.preventDefault();
        open(entry);
        const links = [...entry.panel.querySelectorAll('a[href]')];
        (event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
      });
    });
    nav.dataset.iraDropdownsReady = 'true';
    listen(nav, 'pointerleave', () => entries.forEach(scheduleClose));
    listen(document, 'pointerdown', (event) => {
      if (!nav.contains(event.target)) entries.forEach(close);
    });
    listen(document, 'keydown', (event) => {
      if (event.key !== 'Escape') return;
      const active = entries.find((entry) => entry.item.classList.contains('is-menu-open'));
      if (!active) return;
      const returnFocus = active.item.contains(document.activeElement);
      entries.forEach(close);
      if (returnFocus) {
        restoringFocus = true;
        active.trigger.focus();
        restoringFocus = false;
      }
    });
    listen(desktop, 'change', () => entries.forEach((entry) => { entry.hovered = false; entry.pressedOpen = null; close(entry); }));
    listen(document, 'shopify:section:unload', (event) => {
      if (event.target.contains(header)) { entries.forEach(close); controller.abort(); }
    });
  }

  function initHeader(root = document) {
    qsa('[data-ira-reference-header]', root).forEach((header) => {
      if (header.dataset.ready === 'true') return;
      header.dataset.ready = 'true';
      initDesktopMenus(header);
      const drawer = header.querySelector('[data-ref-mobile-menu]');
      const searchOverlay = document.querySelector('[data-ref-search-overlay]');
      const cartOverlay = document.querySelector('[data-ref-cart-overlay]');
      const searchInput = searchOverlay?.querySelector('[data-ref-search-input]');
      const predictiveResults = searchOverlay?.querySelector('[data-ref-predictive-results]');
      const predictiveStatus = searchOverlay?.querySelector('[data-ref-predictive-status]');
      const searchType = searchOverlay?.querySelector('[data-ref-search-type]');
      const searchPrice = searchOverlay?.querySelector('[data-ref-search-price]');
      let predictiveProducts = [];
      let searchTimer;
      let searchController;
      const setOverlay = (overlay, isOpen) => {
        if (!overlay) return;
        overlay.hidden = !isOpen;
        document.documentElement.classList.toggle('ref-menu-open', isOpen);
      };
      const open = () => {
        if (!drawer) return;
        drawer.hidden = false;
        document.documentElement.classList.add('ref-menu-open');
      };
      const close = () => {
        if (!drawer) return;
        drawer.hidden = true;
        document.documentElement.classList.remove('ref-menu-open');
      };
      header.querySelector('[data-ref-menu-open]')?.addEventListener('click', open);
      header.querySelector('[data-ref-menu-close]')?.addEventListener('click', close);
      header.querySelector('[data-ref-search-open]')?.addEventListener('click', () => {
        setOverlay(searchOverlay, true);
        window.setTimeout(() => searchInput?.focus(), 50);
      });
      searchOverlay?.querySelector('[data-ref-search-close]')?.addEventListener('click', () => setOverlay(searchOverlay, false));
      header.querySelector('[data-ref-cart-open]')?.addEventListener('click', () => setOverlay(cartOverlay, true));
      cartOverlay?.querySelector('[data-ref-cart-close]')?.addEventListener('click', () => setOverlay(cartOverlay, false));
      cartOverlay?.addEventListener('click', (event) => {
        if (event.target === cartOverlay) setOverlay(cartOverlay, false);
      });
      qsa('[data-ref-search-term]', searchOverlay).forEach((button) => {
        button.addEventListener('click', () => {
          if (!searchInput) return;
          searchInput.value = button.dataset.refSearchTerm || '';
          searchInput.closest('form')?.requestSubmit();
        });
      });
      const renderPredictive = () => {
        if (!predictiveResults || !predictiveStatus) return;
        const type = searchType?.value.toLowerCase() || '';
        const maximum = Number(searchPrice?.value || 0);
        const matches = predictiveProducts.filter((product) => {
          const productType = String(product.type || product.product_type || '').toLowerCase();
          const title = String(product.title || '').toLowerCase();
          const typeMatch = !type || productType.includes(type.replace(/s$/, '')) || title.includes(type.replace(/s$/, ''));
          const priceMatch = !maximum || Number(product.price || product.price_min || 0) <= maximum;
          return typeMatch && priceMatch;
        });
        predictiveResults.replaceChildren();
        matches.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'predictive-product';
          link.href = product.url;
          const image = document.createElement('img');
          const source = product.featured_image?.url || product.image || product.featured_image || '';
          if (source) {
            image.src = source;
            image.alt = '';
            image.loading = 'lazy';
            link.append(image);
          }
          const copy = document.createElement('span');
          const titleNode = document.createElement('b');
          titleNode.textContent = product.title;
          const priceNode = document.createElement('small');
          const price = Number(product.price || product.price_min || 0);
          priceNode.textContent = price ? new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0 }).format(price) : '';
          copy.append(titleNode, priceNode);
          link.append(copy);
          predictiveResults.append(link);
        });
        predictiveStatus.textContent = matches.length ? `${matches.length} suggested ${matches.length === 1 ? 'piece' : 'pieces'}` : (searchInput?.value.trim().length > 1 ? 'No close matches. Press Enter to see all results.' : '');
      };
      const searchPredictive = async () => {
        const query = searchInput?.value.trim() || '';
        if (query.length < 2) {
          predictiveProducts = [];
          renderPredictive();
          return;
        }
        searchController?.abort();
        searchController = new AbortController();
        if (predictiveStatus) predictiveStatus.textContent = 'Finding pieces…';
        try {
          const endpoint = searchOverlay?.dataset.refPredictiveUrl || '/search/suggest';
          const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last' });
          const response = await fetch(`${endpoint}.json?${params}`, { signal: searchController.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const payload = await response.json();
          predictiveProducts = payload.resources?.results?.products || [];
          renderPredictive();
        } catch (error) {
          if (error.name === 'AbortError') return;
          predictiveProducts = [];
          if (predictiveStatus) predictiveStatus.textContent = 'Press Enter to search all jewellery.';
        }
      };
      searchInput?.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(searchPredictive, 220);
      });
      searchType?.addEventListener('change', renderPredictive);
      searchPrice?.addEventListener('change', renderPredictive);
      drawer?.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
      });

      qsa('.nav-item', header).forEach((navItem) => {
        const previewImage = navItem.querySelector('[data-ref-menu-image]');
        const previewCaption = navItem.querySelector('[data-ref-menu-caption]');
        const previewLinks = qsa('[data-ref-menu-preview]', navItem);
        if (!previewImage || !previewLinks.length) return;

        const updatePreview = (link) => {
          const nextSource = link?.dataset.refMenuPreview || previewImage.dataset.refMenuDefaultSrc;
          const nextLabel = link?.dataset.refMenuLabel || previewCaption?.dataset.refMenuDefaultLabel || '';
          if (nextSource && previewImage.src !== nextSource) previewImage.src = nextSource;
          previewImage.alt = nextLabel;
          if (previewCaption) previewCaption.textContent = nextLabel;
        };

        previewLinks.forEach((link) => {
          link.addEventListener('pointerenter', () => updatePreview(link));
          link.addEventListener('focus', () => updatePreview(link));
        });
        navItem.addEventListener('pointerleave', () => updatePreview());
      });
    });
  }

  function initCollectionEditorials(root = document) {
    qsa('[data-ref-collection-editorial]', root).forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const cards = qsa('[data-ref-collection-card]', section);
      const tabs = qsa('[data-ref-collection-tab]', section);
      const stack = section.querySelector('.collection-card-stack');
      if (!cards.length) return;
      const defaultIndex = Math.floor((cards.length - 1) / 2);

      const activate = (nextIndex) => {
        const index = (nextIndex + cards.length) % cards.length;
        cards.forEach((card, cardIndex) => card.classList.toggle('active', cardIndex === index));
        tabs.forEach((tab, tabIndex) => tab.classList.toggle('active', tabIndex === index));
      };

      cards.forEach((card, index) => {
        const enterCard = (event) => {
          if (event.pointerType === 'touch') return;
          activate(index);
        };
        card.addEventListener('pointerenter', enterCard);
        card.addEventListener('mouseenter', enterCard);
        card.addEventListener('focus', () => activate(index));
      });
      stack?.addEventListener('pointerleave', () => activate(defaultIndex));

      tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', () => activate(index));
        tab.addEventListener('focus', () => activate(index));
      });
      section.querySelector('.collection-tabs')?.addEventListener('pointerleave', () => activate(defaultIndex));
      activate(defaultIndex);
    });
  }

  function initRails(root = document) {
    qsa('[data-ref-rail]', root).forEach((rail) => {
      if (rail.dataset.ready === 'true') return;
      rail.dataset.ready = 'true';
      const section = rail.closest('section');
      const step = () => Math.max(260, rail.clientWidth * 0.72);
      const autoScroll = rail.dataset.refRailAutoplay === 'true';
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let groupSpan = 0;
      let pauseUntil = 0;

      const pauseBriefly = (duration = 1400) => {
        pauseUntil = performance.now() + duration;
      };

      const prepareInfiniteRail = () => {
        const originals = [...rail.children].filter((item) => !item.hasAttribute('data-ref-rail-clone'));
        if (!autoScroll || originals.length < 2 || reducedMotion.matches) return;

        const cloneSet = () => {
          const fragment = document.createDocumentFragment();
          originals.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-ref-rail-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            [clone, ...clone.querySelectorAll('*')].forEach((node) => {
              [...node.attributes].forEach((attribute) => {
                if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
              });
            });
            fragment.append(clone);
          });
          rail.append(fragment);
        };

        cloneSet();
        const firstClone = rail.querySelector('[data-ref-rail-clone]');
        groupSpan = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
        if (!groupSpan) return;

        while (rail.scrollWidth < groupSpan + rail.clientWidth + 2) cloneSet();
        rail.dataset.autoplayActive = 'true';

        let previousTime = performance.now();
        const tick = (time) => {
          if (!rail.isConnected) return;
          const elapsed = Math.min(64, time - previousTime);
          previousTime = time;

          if (!document.hidden && !reducedMotion.matches && time >= pauseUntil) {
            rail.scrollLeft += (Math.max(8, Number(rail.dataset.refRailSpeed || 20)) * elapsed) / 1000;
          }
          if (groupSpan && rail.scrollLeft >= groupSpan) rail.scrollLeft -= groupSpan;
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);

        const recalculate = () => {
          const progress = groupSpan ? rail.scrollLeft / groupSpan : 0;
          const nextClone = rail.querySelector('[data-ref-rail-clone]');
          groupSpan = nextClone ? nextClone.offsetLeft - originals[0].offsetLeft : groupSpan;
          if (groupSpan) rail.scrollLeft = (progress % 1) * groupSpan;
        };
        new ResizeObserver(recalculate).observe(rail);

        rail.addEventListener('pointerdown', () => pauseBriefly());
        rail.addEventListener('wheel', () => pauseBriefly(), { passive: true });
        rail.addEventListener('focusin', () => pauseBriefly(4000));
      };

      section?.querySelector('[data-ref-rail-prev]')?.addEventListener('click', () => {
        pauseBriefly();
        if (groupSpan && rail.scrollLeft < step()) rail.scrollLeft += groupSpan;
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      section?.querySelector('[data-ref-rail-next]')?.addEventListener('click', () => {
        pauseBriefly();
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
      prepareInfiniteRail();
    });
  }

  function initVibeCarousels(root = document) {
    qsa('.vibe-carousel-section', root).forEach((section) => {
      if (section.dataset.vibeReady === 'true') return;
      section.dataset.vibeReady = 'true';

      const cards = qsa('[data-ref-vibe-card]', section);
      const pills = qsa('[data-ref-vibe-index]', section);
      if (!cards.length) return;

      let activeIndex = Math.max(0, cards.findIndex((card) => card.classList.contains('active')));
      const centerSlot = Math.min(2, Math.floor(cards.length / 2));

      const activate = (nextIndex) => {
        activeIndex = (nextIndex + cards.length) % cards.length;
        const firstVisibleIndex = activeIndex - centerSlot;

        cards.forEach((card, cardIndex) => {
          const slot = (cardIndex - firstVisibleIndex + cards.length) % cards.length;
          card.classList.toggle('active', cardIndex === activeIndex);
          card.style.order = String(slot);
          card.dataset.vibeSlot = String(slot);
          [...card.classList].forEach((className) => {
            if (className.startsWith('vibe-offset-')) card.classList.remove(className);
          });
          card.classList.add(`vibe-offset-${slot}`);
        });

        pills.forEach((pill, pillIndex) => {
          const active = pillIndex === activeIndex;
          pill.classList.toggle('active', active);
          pill.setAttribute('aria-pressed', String(active));
        });
      };

      pills.forEach((pill) => {
        pill.addEventListener('click', () => activate(Number(pill.dataset.refVibeIndex || 0)));
      });
      section.querySelector('[data-ref-vibe-prev]')?.addEventListener('click', () => activate(activeIndex - 1));
      section.querySelector('[data-ref-vibe-next]')?.addEventListener('click', () => activate(activeIndex + 1));
      activate(activeIndex);
    });
  }

  function initProduct(root = document) {
    qsa('[data-ref-product]', root).forEach((productRoot) => {
      if (productRoot.dataset.ready === 'true') return;
      productRoot.dataset.ready = 'true';

      const galleryImage = productRoot.querySelector('.ira-pdp-main-image, [data-ref-main-image], .main-image > img');
      const setComposition = productRoot.querySelector('[data-ref-set-composition]');
      const setHotspots = productRoot.querySelector('.set-hotspots');
      const zoomDialog = document.querySelector('[data-ref-zoom-dialog]');
      const zoomImageFrame = zoomDialog?.querySelector('[data-ref-zoom-image]');
      const zoomImage = zoomImageFrame?.querySelector('img');
      const zoomSet = zoomDialog?.querySelector('[data-ref-zoom-set]');
      const sizeDialog = document.querySelector('[data-ref-size-dialog]');
      const setThumb = productRoot.querySelector('[data-ref-set-thumb]');
      setThumb?.addEventListener('click', () => {
        qsa('[data-ref-thumb], [data-ref-set-thumb]', productRoot).forEach((item) => {
          const isActive = item === setThumb;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-current', String(isActive));
        });
        galleryImage?.classList.remove('is-gallery-active');
        if (galleryImage) galleryImage.hidden = true;
        setComposition?.removeAttribute('hidden');
        setHotspots?.removeAttribute('hidden');
      });
      qsa('[data-ref-thumb]', productRoot).forEach((thumb) => {
        thumb.addEventListener('click', () => {
          qsa('[data-ref-thumb], [data-ref-set-thumb]', productRoot).forEach((item) => {
            const isActive = item === thumb;
            item.classList.toggle('active', isActive);
            item.setAttribute('aria-current', String(isActive));
          });
          thumb.classList.add('active');
          const nextImage = thumb.dataset.refThumb;
          if (galleryImage && nextImage) {
            galleryImage.removeAttribute('srcset');
            galleryImage.removeAttribute('sizes');
            galleryImage.src = nextImage;
            galleryImage.alt = thumb.querySelector('img')?.alt || productRoot.dataset.refProductTitle || '';
            galleryImage.hidden = false;
            galleryImage.classList.add('is-gallery-active');
            setComposition?.setAttribute('hidden', '');
            setHotspots?.setAttribute('hidden', '');
          }
        });
      });

      const form = productRoot.querySelector('form[action*="/cart/add"]');
      const variantsNode = productRoot.parentElement?.querySelector('[data-ref-variants]');
      let variants = [];
      try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}
      const optionGroups = qsa('[data-ref-option]', productRoot);

      optionGroups.forEach((group) => {
        qsa('[data-option-value]', group).forEach((button) => {
          button.addEventListener('click', () => {
            qsa('[data-option-value]', group).forEach((item) => item.classList.remove('active'));
            button.classList.add('active');
            const selected = optionGroups.map((item) => item.querySelector('[data-option-value].active')?.dataset.optionValue);
            const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
            if (!form) return;
            if (!variant) {
              const unavailableButton = form.querySelector('[data-ref-add]');
              if (unavailableButton) { unavailableButton.disabled = true; unavailableButton.textContent = 'Unavailable'; }
              document.querySelector('[data-ref-sticky-add]')?.setAttribute('disabled', '');
              return;
            }
            const idInput = form.querySelector('[data-ref-variant-id]');
            const addButton = form.querySelector('[data-ref-add]');
            if (idInput) idInput.value = variant.id;
            if (addButton) {
              addButton.disabled = !variant.available;
              addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
            }
            const stickyAdd = document.querySelector('[data-ref-sticky-add]');
            if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = addButton?.textContent || 'Add to cart'; }
            const notifyCard = productRoot.querySelector('[data-ref-notify-card]');
            if (notifyCard) notifyCard.hidden = variant.available;
            const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
              style: 'currency',
              currency: window.Shopify?.currency?.active || 'INR',
              maximumFractionDigits: 0
            });
            const price = productRoot.querySelector('[data-ref-price]');
            if (price) price.textContent = formatter.format(variant.price / 100);
            const stickyPrice = document.querySelector('.mobile-pdp-sticky > span');
            if (stickyPrice) stickyPrice.textContent = formatter.format(variant.price / 100);
          });
        });
      });

      productRoot.querySelector('[data-ref-zoom]')?.addEventListener('click', () => {
        if (!zoomDialog || !zoomImage) return;
        const showCompleteSet = setComposition && !setComposition.hidden;
        if (showCompleteSet && zoomSet) {
          zoomSet.replaceChildren(...[...setComposition.children].map((child) => child.cloneNode(true)));
          zoomSet.classList.toggle('ira-zoom-set--single', setComposition.classList.contains('set-composition--single'));
          zoomSet.hidden = false;
          zoomImageFrame.hidden = true;
        } else {
          if (!galleryImage) return;
          zoomImage.removeAttribute('srcset');
          zoomImage.removeAttribute('sizes');
          zoomImage.loading = 'eager';
          const hoverImage = productRoot.querySelector('.ira-pdp-hover-image');
          const displayedImage = hoverImage && getComputedStyle(hoverImage).opacity === '1' ? hoverImage : galleryImage;
          zoomImage.src = displayedImage.currentSrc || displayedImage.src;
          zoomImage.alt = displayedImage.alt;
          zoomImageFrame.hidden = false;
          if (zoomSet) zoomSet.hidden = true;
        }
        zoomDialog.showModal?.();
      });
      zoomDialog?.querySelector('[data-ref-dialog-close]')?.addEventListener('click', () => zoomDialog.close());
      zoomDialog?.addEventListener('click', (event) => { if (event.target === zoomDialog) zoomDialog.close(); });
      qsa('[data-ref-size-guide]', productRoot).forEach((button) => button.addEventListener('click', () => sizeDialog?.showModal?.()));
      sizeDialog?.querySelector('[data-ref-dialog-close]')?.addEventListener('click', () => sizeDialog.close());
      sizeDialog?.addEventListener('click', (event) => { if (event.target === sizeDialog) sizeDialog.close(); });
      const delivery = productRoot.querySelector('[data-ref-delivery]');
      const deliveryInput = delivery?.querySelector('input');
      const deliveryStatus = delivery?.querySelector('[data-ref-delivery-status]');
      delivery?.querySelector('button')?.addEventListener('click', () => {
        const valid = /^\d{6}$/.test(deliveryInput?.value || '');
        if (deliveryStatus) deliveryStatus.textContent = valid ? `Delivery options for ${deliveryInput.value} will be confirmed at checkout.` : 'Enter a valid 6-digit pincode.';
        if (!valid) deliveryInput?.focus();
      });
      productRoot.querySelector('[data-ref-native-share]')?.addEventListener('click', async () => {
        const status = productRoot.querySelector('[data-ref-share-status]');
        const data = { title: productRoot.dataset.refProductTitle || document.title, url: productRoot.dataset.refProductUrl || location.href };
        try {
          if (navigator.share) await navigator.share(data);
          else {
            await navigator.clipboard.writeText(data.url);
            if (status) status.textContent = 'Link copied. Paste it into Instagram or any app.';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the page address from your browser to share this piece.';
        }
      });
    });
  }

  function initToneCards(root = document) {
    if (!matchMedia('(hover: none)').matches) return;
    if (matchMedia('(max-width: 760px)').matches) return;
    qsa('.tone-paper', root).forEach((card) => {
      if (card.dataset.touchReady === 'true') return;
      card.dataset.touchReady = 'true';
      card.addEventListener('click', (event) => {
        if (card.classList.contains('revealed')) return;
        event.preventDefault();
        qsa('.tone-paper.revealed', card.closest('.tone-deck') || document).forEach((item) => item.classList.remove('revealed'));
        card.classList.add('revealed');
      });
    });
  }

  function initMotionVideos(root = document) {
    qsa('.motion-stories video, .packaging-video video, .craft-film video', root).forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const play = () => video.play().catch(() => {});
      if (video.readyState >= 2) play();
      else video.addEventListener('canplay', play, { once: true });
    });
  }

  function initWishlist(root = document) { window.IraWishlist?.sync(root); }

  function initWishlistPage(root = document) {
    qsa('[data-ref-wishlist-page]', root).forEach((page) => {
      if (page.dataset.ready === 'true') return;
      page.dataset.ready = 'true';
      const grid = page.querySelector('[data-ref-wishlist-grid]');
      const empty = page.querySelector('[data-ref-wishlist-empty]');
      const loading = page.querySelector('[data-ref-wishlist-loading]');
      const share = page.querySelector('[data-ref-wishlist-share]');
      const status = page.querySelector('[data-ref-wishlist-status]');
      const queryItems = new URL(location.href).searchParams.get('items')?.split(',').filter(Boolean) || [];
      const normalize = (items) => [...new Set((Array.isArray(items) ? items : []).filter((path) => /^\/products\/[a-z0-9-]+$/i.test(path)))];
      const savedPaths = () => {
        try { return normalize(JSON.parse(localStorage.getItem('ira-wishlist') || '[]')); } catch (_) { return []; }
      };
      const shared = queryItems.length > 0;
      let paths = shared ? normalize(queryItems.map((handle) => `/products/${handle}`)) : savedPaths();
      const loadingText = loading?.textContent || '';
      let renderVersion = 0;
      const productsByPath = new Map();

      const shareUrl = () => {
        const url = new URL(location.href);
        url.search = '';
        url.searchParams.set('view', 'wishlist');
        url.searchParams.set('items', paths.map((path) => path.split('/').pop()).join(','));
        url.hash = '';
        return url.toString();
      };
      const updateShare = () => {
        const url = shareUrl();
        const whatsapp = page.querySelector('[data-ref-wishlist-whatsapp]');
        const email = page.querySelector('[data-ref-wishlist-email]');
        if (whatsapp) whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`My IRA wishlist — ${url}`)}`;
        if (email) email.href = `mailto:?subject=${encodeURIComponent('My IRA wishlist')}&body=${encodeURIComponent(url)}`;
        if (share) share.hidden = paths.length === 0;
      };
      const format = (price) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0 }).format(Number(price || 0) / 100);
      const createWishlistCard = (product, path) => {
        const card = document.createElement('article');
        card.className = 'product-card';
        card.dataset.productCard = '';
        const media = document.createElement('div');
        media.className = 'product-media';
        const imageLink = document.createElement('a');
        imageLink.href = path;
        const image = document.createElement('img');
        const source = product.featured_image?.url || product.featured_image || product.images?.[0] || '';
        image.src = source;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.width = 900;
        image.height = 1100;
        imageLink.append(image);
        const remove = document.createElement('button');
        remove.className = 'heart active';
        remove.type = 'button';
        remove.setAttribute('aria-label', `Remove ${product.title} from wishlist`);
        remove.setAttribute('aria-pressed', 'true');
        const heart = page.querySelector('[data-ref-wishlist-heart]');
        if (heart) remove.append(heart.content.cloneNode(true));
        remove.addEventListener('click', () => {
          const hadFocus = document.activeElement === remove;
          const index = [...grid.children].indexOf(card);
          if (shared) {
            // Editing a shared view must not replace the visitor's personal wishlist.
            paths = paths.filter((item) => item !== path);
            render();
          } else if (!window.IraWishlist?.set(savedPaths().filter((item) => item !== path))) {
            if (loading) { loading.hidden = false; loading.textContent = page.dataset.saveError; }
            return;
          }
          if (hadFocus && !remove.isConnected && (document.activeElement === document.body || !document.activeElement?.isConnected)) {
            const next = grid.children[Math.min(index, grid.children.length - 1)]?.querySelector('button');
            (next || empty?.querySelector('a'))?.focus();
          }
        });
        media.append(imageLink, remove);
        const info = document.createElement('a');
        info.className = 'product-info';
        info.href = path;
        const title = document.createElement('h3');
        title.textContent = product.title || '';
        const price = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = format(product.price);
        price.append(strong);
        info.append(title, price);
        const view = document.createElement('a');
        view.className = 'card-add';
        view.href = path;
        view.textContent = 'View piece';
        card.append(media, info, view);
        return card;
      };

      page.querySelector('[data-ref-wishlist-copy]')?.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(shareUrl());
          if (status) status.textContent = 'Wishlist link copied.';
        } catch (_) {
          if (status) status.textContent = 'Copy the address from your browser to share this wishlist.';
        }
      });
      page.querySelector('[data-ref-wishlist-native]')?.addEventListener('click', async () => {
        try {
          if (navigator.share) await navigator.share({ title: 'My IRA wishlist', url: shareUrl() });
          else {
            await navigator.clipboard.writeText(shareUrl());
            if (status) status.textContent = 'Link copied. Paste it into Instagram or any app.';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the wishlist link to share it.';
        }
      });

      const render = async () => {
        const version = ++renderVersion;
        if (!shared) paths = savedPaths();
        const requested = [...paths];
        const draw = () => {
          grid?.replaceChildren(...requested.filter(path => productsByPath.has(path)).map(path => createWishlistCard(productsByPath.get(path), path)));
          if (empty) empty.hidden = requested.length > 0;
          updateShare();
        };
        draw();
        const missing = requested.filter(path => !productsByPath.has(path));
        if (loading) { loading.hidden = missing.length === 0; loading.textContent = loadingText; }
        grid?.setAttribute('aria-busy', String(missing.length > 0));
        if (!missing.length) return;
        await Promise.all(missing.map(async (path) => {
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path.slice(1)}.js`);
            if (!response.ok) return;
            const product = await response.json();
            if (product && typeof product.title === 'string') productsByPath.set(path, product);
          } catch (_) { /* Preserve saved paths; a temporary lookup failure is not an empty wishlist. */ }
        }));
        // An older request must not restore a piece removed while its image/data loaded.
        if (version !== renderVersion || !page.isConnected) return;
        draw();
        const failed = requested.some(path => !productsByPath.has(path));
        if (loading) { loading.hidden = !failed; loading.textContent = failed ? page.dataset.loadError : loadingText; }
        grid?.setAttribute('aria-busy', 'false');
      };
      const onChange = () => { if (!shared) render(); };
      const onUnload = (event) => {
        if (!event.target.contains(page)) return;
        ++renderVersion;
        document.removeEventListener('ira:wishlist:change', onChange);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('ira:wishlist:change', onChange);
      document.addEventListener('shopify:section:unload', onUnload);
      render();
    });
  }

  function initFirstPurchase(root = document) {
    qsa('[data-ref-first-purchase]', root).forEach((offer) => {
      if (offer.dataset.ready === 'true') return;
      offer.dataset.ready = 'true';
      if (offer.hidden) return;
      offer.hidden = true;
      const delay = Math.max(0, Number(offer.dataset.refDelay || 1)) * 1000;
      window.setTimeout(() => {
        if (sessionStorage.getItem('ira-welcome-dismissed') !== 'true') offer.hidden = false;
      }, delay);
      offer.querySelector('[data-ref-first-purchase-close]')?.addEventListener('click', () => {
        offer.hidden = true;
        sessionStorage.setItem('ira-welcome-dismissed', 'true');
      });
    });
  }

  function initGifting(root = document) {
    qsa('[data-ref-gifting]', root).forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const modes = qsa('[data-ref-gift-mode]', section);
      const filterGroups = qsa('[data-ref-gift-filter-group]', section);
      const products = qsa('[data-ref-gift-product]', section);
      const filterTitle = section.querySelector('[data-ref-gift-filter-title]');
      let activeMode = 'occasion';
      const activateFilter = (filter) => {
        if (!filter) return;
        const value = filter.dataset.refGiftFilter;
        const matches = products.filter((product) => product.dataset[activeMode] === value);
        section.dataset.activeGiftFilter = value.toLowerCase().replace(/\s+/g, '-');
        qsa('[data-ref-gift-filter]', section).forEach((item) => item.classList.toggle('active', item === filter));
        products.forEach((product) => {
          product.hidden = matches.length > 0 && product.dataset[activeMode] !== value;
          const label = product.querySelector(':scope > span');
          if (label) {
            const labelValue = activeMode === 'occasion' ? product.dataset.occasion : product.dataset.audience;
            label.textContent = `${labelValue} pick`;
            label.style.background = activeMode === 'occasion' ? (product.dataset.occasionColor || 'var(--rose)') : 'var(--rose)';
          }
        });
      };
      const activateMode = (mode) => {
        activeMode = mode.dataset.refGiftMode;
        modes.forEach((item) => {
          const selected = item === mode;
          item.classList.toggle('active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        filterGroups.forEach((group) => { group.hidden = group.dataset.refGiftFilterGroup !== activeMode; });
        if (filterTitle) filterTitle.textContent = activeMode === 'occasion' ? 'Shop by Occasion' : 'Shop for Them';
        const activeGroup = filterGroups.find((group) => group.dataset.refGiftFilterGroup === activeMode);
        activateFilter(activeGroup?.querySelector('[data-ref-gift-filter]'));
      };
      qsa('[data-ref-gift-filter]', section).forEach((filter) => filter.addEventListener('click', () => activateFilter(filter)));
      modes.forEach((mode) => mode.addEventListener('click', () => activateMode(mode)));
      if (modes[0]) activateMode(modes[0]);
      const check = section.querySelector('.gift-delivery button');
      const input = section.querySelector('.gift-delivery input');
      const note = section.querySelector('[data-ref-gift-delivery-note]');
      const deliveryResult = section.dataset.refDeliveryResult;
      const checkDelivery = () => {
        if (!note || !input) return;
        const pin = input.value.trim();
        if (!/^[1-9]\d{5}$/.test(pin)) {
          note.textContent = section.dataset.refInvalidPincode;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.value = pin;
        input.removeAttribute('aria-invalid');
        // No courier estimate source is connected; do not infer a date from the pincode.
        note.textContent = deliveryResult;
      };
      check?.addEventListener('click', checkDelivery);
      input?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          checkDelivery();
        }
      });
      input?.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        if (note) note.textContent = '';
      });

      const hamperToggles = qsa('[data-ref-hamper-toggle]', section);
      const hamperAdd = section.querySelector('[data-ref-hamper-add]');
      const hamperCount = section.querySelector('[data-ref-hamper-count]');
      const hamperStatus = section.querySelector('[data-ref-hamper-status]');
      const hamperNote = section.querySelector('[data-ref-hamper-note]');
      const selectedHamper = new Map();
      const renderHamper = () => {
        const size = selectedHamper.size;
        if (hamperCount) hamperCount.textContent = `${size} ${size === 1 ? 'piece' : 'pieces'} selected`;
        if (hamperAdd) hamperAdd.disabled = size === 0;
      };
      hamperToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const product = toggle.closest('[data-ref-gift-product]');
          const variantId = Number(product?.dataset.hamperVariant || 0);
          if (!variantId) return;
          if (selectedHamper.has(variantId)) selectedHamper.delete(variantId);
          else selectedHamper.set(variantId, product?.dataset.hamperTitle || 'IRA piece');
          const selected = selectedHamper.has(variantId);
          toggle.setAttribute('aria-pressed', String(selected));
          toggle.textContent = selected ? '✓ Added to hamper' : '+ Add to hamper';
          renderHamper();
        });
      });
      hamperAdd?.addEventListener('click', async () => {
        if (!selectedHamper.size || hamperAdd.disabled) return;
        const hadFocus = document.activeElement === hamperAdd;
        let added = false;
        hamperAdd.disabled = true;
        if (hamperStatus) hamperStatus.textContent = 'Adding your hamper to the bag…';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [...selectedHamper.keys()].map((id) => ({ id, quantity: 1, properties: { _ira_gift_source: 'gifting_page' } })) })
          });
          if (!response.ok) throw new Error('Unable to add hamper');
          added = true;
          const giftNote = hamperNote?.value.trim();
          if (giftNote) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: `Gift note: ${giftNote}` })
            });
          }
          await window.IraCart.refresh(false, true);
          if (hamperStatus) hamperStatus.textContent = '';
        } catch (_) {
          if (hamperStatus) hamperStatus.textContent = added
            ? 'Added to your bag, but the drawer could not refresh. Open your bag or reload to review it.'
            : 'The hamper could not be added. Please try again.';
        } finally {
          hamperAdd.disabled = false;
          if (hadFocus && document.activeElement === document.body && hamperAdd.isConnected) hamperAdd.focus({ preventScroll: true });
        }
      });
      renderHamper();
    });
  }

  function initToneShop(root = document) {
    qsa('[data-ref-tone-shop]', root).forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const tabs = qsa('[data-ref-tone-tab]', section);
      const panels = qsa('[data-ref-tone-panel]', section);
      if (!tabs.length || !panels.length) return;

      const activate = (tone, options = {}) => {
        const nextTab = tabs.find((tab) => tab.dataset.refToneTab === tone) || tabs[0];
        const activeTone = nextTab.dataset.refToneTab;

        tabs.forEach((tab) => {
          const active = tab === nextTab;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((panel) => {
          const active = panel.dataset.refTonePanel === activeTone;
          panel.hidden = !active;
          panel.classList.toggle('active', active);
        });

        if (options.focus) nextTab.focus();
        if (options.updateUrl && window.history?.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('tone', activeTone);
          url.hash = 'tone-shop';
          window.history.replaceState({}, '', url);
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.refToneTab, { updateUrl: true }));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activate(tabs[nextIndex].dataset.refToneTab, { focus: true, updateUrl: true });
        });
      });

      const requestedTone = new URL(window.location.href).searchParams.get('tone');
      activate(requestedTone || section.dataset.defaultTone);
    });
  }

  function init(root = document) {
    initCarousels(root);
    initAnnouncement(root);
    initOfferStrips(root);
    initHeader(root);
    initCollectionEditorials(root);
    initRails(root);
    initVibeCarousels(root);
    initProduct(root);
    initToneCards(root);
    initWishlist(root);
    initWishlistPage(root);
    initFirstPurchase(root);
    initGifting(root);
    initToneShop(root);
    initMotionVideos(root);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    qsa('[data-ref-mobile-menu]').forEach((drawer) => { drawer.hidden = true; });
    qsa('[data-ref-search-overlay], [data-ref-cart-overlay]').forEach((overlay) => { overlay.hidden = true; });
    document.documentElement.classList.remove('ref-menu-open');
  });
})();
